// extracted by mini-css-extract-plugin
module.exports = {"otherAdsScriptsWrapper":"other-ads-scripts_otherAdsScriptsWrapper__11viM"};